import { lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '@reducers/index';
import LoaderComponent from '@components/atom/layout/loader';
import SelectBox from '@components/template/ranking/selectBox';
import UpdateInfoBox from '@components/template/ranking/updateInfoBox';
import ChartBox from '@components/template/ranking/chartBox';

const AppInfo = lazy(() => import('@components/template/layout/appInfo/appInfo'));

const Mover = () => {
  const { biggestMover, biggestMoverRequestStatus } = useSelector(({ ranking }: RootState) => ranking);

  return (
    <>
      <div className="app-info">
        <Suspense fallback={<LoaderComponent />}>
          <AppInfo />
        </Suspense>
      </div>
      <SelectBox />
      <UpdateInfoBox data={biggestMover} />
      <ChartBox
        freeRankingData={biggestMover?.freeRankingData}
        paidRankingData={biggestMover?.paidRankingData}
        grossRankingData={biggestMover?.grossRankingData}
        isLoading={biggestMoverRequestStatus === 'pending' ? true : false}
      />
    </>
  );
};

export default Mover;
